import { createContext, useContext } from "react";
import type { ReactNode } from "react";

export type MenuFeatures = {
  showPrices: boolean;
  showDiscountPrices: boolean;
  showDescriptions: boolean;
  showCurrencySwitcher: boolean;
  imageFit: "cover" | "contain";
};

export type SocialLink = {
  platform:
  | "instagram"
  | "facebook"
  | "x"
  | "tiktok"
  | "snapchat"
  | "youtube"
  | "telegram"
  | "linkedin"
  | "threads";
  url: string;
};

export type MenuConfig = {
  features: MenuFeatures;
  socialLinks: SocialLink[];
};

const defaultConfig: MenuConfig = {
  features: {
    showPrices: true,
    showDiscountPrices: true,
    showDescriptions: true,
    showCurrencySwitcher: false,
    imageFit: "cover",
  },
  socialLinks: [],
};

const MenuConfigContext = createContext<MenuConfig>(defaultConfig);

export const MenuConfigProvider = ({
  children,
  config,
}: {
  children: ReactNode;
  config?: Partial<MenuConfig>;
}) => {
  const merged: MenuConfig = {
    features: { ...defaultConfig.features, ...(config?.features ?? {}) },
    socialLinks: config?.socialLinks ?? defaultConfig.socialLinks,
  };

  return (
    <MenuConfigContext.Provider value={merged}>
      {children}
    </MenuConfigContext.Provider>
  );
};

export const useMenuConfig = () => useContext(MenuConfigContext);
